import React,{useState} from "react"
import {BlueText} from './styles'

function WordLimit({ content, limit }) {
    const [readmoreToggle, setReadmoreToggle] = useState(false)
    if (content.length <= limit) return content
    return (
      <>
        {content.length > limit ? (
          readmoreToggle ? (
            <>
              {content}{' '}
              <BlueText onClick={() => setReadmoreToggle(false)}>
                ...Read Less
              </BlueText>
            </>
          ) : (
            <>
              {content.slice(0, limit)}{' '}
              <BlueText onClick={() => setReadmoreToggle(true)}>
                ...Read More
              </BlueText>
            </>
          )
        ) : null}{' '}
      </>
    )
  }

  export default WordLimit